package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
data class AdminUsageDay(val day: String, val costUsd: Double, val events: Int, val byProvider: Map<String, Double>)

@Serializable
data class AdminUsageUser(val userId: String, val costUsd: Double, val events: Int)

@Serializable
data class AdminUsageReport(
    val sinceMs: Long,
    val totalCostUsd: Double,
    val anonymousCostUsd: Double,
    val days: List<AdminUsageDay>,
    val topUsers: List<AdminUsageUser>
)

@Serializable
data class AdminUserDto(
    val id: String,
    val email: String,
    val status: String,
    val createdAtMs: Long,
    val lastLoginAtMs: Long? = null,
    val planId: String,
    val subscriptionStatus: String? = null,
    val creditsUsed: Int,
    val creditsLimit: Int? = null,
    val purchasedCredits: Int,
    val costUsd30d: Double
)

@Serializable
data class AdminGrantCreditsRequest(
    /** Positive adds purchased (non-expiring) credits, negative removes them. */
    val credits: Int,
    val note: String? = null
)

@Serializable
data class AdminUserStatusRequest(
    val status: String
)

@Serializable
data class AdminAuditDto(
    val id: Long,
    val createdAtMs: Long,
    val admin: String,
    val action: String,
    val target: String,
    val details: String? = null
)

@Serializable
data class AdminMeDto(
    val isAdmin: Boolean
)
